import {
    IResourceComponentsProps,
    useNavigation,
    useTable,

    useList,
    useShow,
    useGetIdentity,
    useUpdate,
  
    useImport,
    useCreateMany,
  
    CrudFilter,
    useUpdateMany,
  } from '@pankod/refine-core'
  import 'styles/custom.css'
  import {
    List,
    RefreshButton,
    Table,
    Space,
    Typography,
    EditButton,
    ShowButton,
    
    useModalForm,
    Icons,
    TagField,
    Progress,
    Menu,
    Tag,
    Form,
    Button,
    Popconfirm,
    message,
    Modal,
    Checkbox,
    Row,
    Col,
    Input,
    Select,
    Spin,
    Badge,
    useModal,
    Tabs,
    Divider,
  } from '@pankod/refine-antd'
  
  import { CSVLink } from 'react-csv'
  
  import ReactMarkdown from 'react-markdown'
  import { IGrade, IQuestion, IQuestionType,} from 'interfaces'
  import { useEffect, useState } from 'react'
  import { TableColumnsType } from 'antd'
  import { CreateQuestion } from 'pages/questions'
  import { EditQuestion } from 'pages/questions'
  import { QuestionFilter } from 'components/filters/questionFilter'
  import metaData from 'metadata/questions'
  import wrMetadata from 'metadata/workrequests'
  import { getWorkRequestStatusCount, CompletionStatus, createMailForSecondReviewer, createMailForSecondApprover, ReactMarkdownAllowedElements } from 'helpers'
  
  import { useUserContext } from 'context/user'
  import { createLogForSecondApprover, createLogForSecondReviewer } from 'gql/mutations'
  import { Source } from 'graphql'
import { getParentQuestionIds } from 'gql/query'
  
  // import { UploadQuestions } from './question_import_modal'
  const { Search } = Input;
  const { PlusOutlined, ExportOutlined, MailOutlined, AppstoreOutlined, SettingOutlined, FilterOutlined, DeleteOutlined } = Icons
  const { Text, Link } = Typography
  
  type QuestionListProps = {
    request?: any
    updatePercentage?: any
  }
  type QuestionType = {
    title: string
    description: string
    created_by: string
    creator_id: string
    status: string
    subject_id: string
    theme_id: string
    sub_theme_id: string
    topic_id: string
    grade_ids: object[]
    option_type: string
    question_type_id: string
    bloom_level_id: string
    difficulty_level_id: string
    report_theme_id: string
    centa_standard_id: string
    strand_id: string
    centa_concept_id: string
    tn_taxonomy_id: string
    explanation_type_id: string
    competency_id: string
    teacher_level_id: string
    option_details: object[]
  }
  interface QuestionSearch{
    question_search:string
  }
  const { confirm } = Modal
  
  export const RetiredQuestionList: React.FC<IResourceComponentsProps> = () => {
    const { data: user } = useGetIdentity()
    const { mutate :rePublishQuestions} = useUpdateMany();
    const { userRole } = useUserContext()
    const { mutate } = useCreateMany<IQuestion>()
    const role = user?.defaultRole
    const { show } = useNavigation()
    const [form] = Form.useForm<IQuestion>()
    const [formSearch] = Form.useForm<QuestionSearch>();
    const [wrFilter, setWRFilter] = useState<CrudFilter[]>([])
    const [qFilter, setQFilter] = useState<CrudFilter[]>([])
    const [tableData, setTableData] = useState<object[]>([])
    const fileReader = new FileReader()
    const [file, setFile] = useState()
    const [loading, setLoading] = useState(false)
    const [messageHide, setHideMessage] = useState(false)
    const [array, setArray] = useState<object[]>([])
    const [totalValidQuestions, setTotalValidQuestions] = useState(0)
    const [tab, setTab] = useState('1')
    const { mutate: updateQuestionActiveFlag } = useUpdate()
    const [showTable, setShowTable] = useState<boolean>(true)
    const [showExportModal, setShowExportModal] = useState(false)
    const { modalProps: uploadProps, show: showUpload, close: closeUpload } = useModal()
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
   
    const [currentFilter, setCurrentFilter] = useState('')
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [parentQuestionIds,setParentQuestionIds]=useState([] as any[])
    const [currentRecord, setCurrentRecord] = useState('')
    const [totalVariantQuestionCount, setTotalVariantQuestionCount] = useState(0)
    const [total, setTotal] = useState(0)
    const [processed, setProcessed] = useState(0)
    const [searchText,setSearchText]=useState('')
    const { mutate:updateSecondReviewers } = useUpdateMany<IQuestion>()
    const { mutate:updateSecondApprovers } = useUpdateMany<IQuestion>()
  useEffect(()=>{
    let arr:any[]=[]
    getParentQuestionIds().then((resp:any)=>{
      resp?.questions?.forEach((element:any) => {
        arr?.push(element?.parent_question_id)
      })
    })
  setParentQuestionIds(arr)
  },[])
    const handleOnSubmit = (fs: any) => {
      if (fs) {
        fileReader.onload = function (event: any) {
          const csvOutput = event.target.result
          csvFileToArray(csvOutput)
        }
  
        fileReader.readAsText(fs)
      }
    }
  
    // const handleChange = (e: any) => {
    //   setFile(e.target.files[0])
    //   setLoading(true)
    //   handleOnSubmit(e.target.files[0])
    // }
    const csvFileToArray = (result: string) => {
      const csvHeader = result.slice(0, result.indexOf('\n')).split(',')
      const csvRows = result.slice(result.indexOf('\n') + 1).split('\n')
  
      const array = csvRows.map(i => {
        const values = i.split(',')
  
        const obj = csvHeader.reduce((object: any, header: any, index: any) => {
          object[header] = values[index]
  
          return object
        }, {})
        return obj
      })
  
      setArray(array)
    }
  
    useEffect(() => {
      let question_arr: QuestionType[] = []
      let optionText = ['Option_A', 'Option_B', 'Option_C', 'Option_D']
      let fillText = ['Fill_Right_Answer_A', 'Fill_Right_Answer_B', 'Fill_Right_Answer_C', 'Fill_Right_Answer_D']
      let optionFlag = ['Option_Flag_A', 'Option_Flag_B', 'Option_Flag_C', 'Option_Flag_D']
      let insightText = ['Insight_A', 'Insight_B', 'Insight_C', 'Insight_D']
      let leftLabelText = ['Left_Label_A', 'Left_Label_B', 'Left_Label_C', 'Left_Label_D']
      let rightLabelTextt = ['Right_Label_A', 'Right_Label_B', 'Right_Label_C', 'Right_Label_D']
      let componentName = ['A', 'B', 'C', 'D']
      if (array.length > 0) {
        array.map((item: any) => {
          let option_details: object[] = []
          let option_flag = ''
  
          if (item?.Question_Type === 'MCQ') {
            optionText.map((options: any, i: any) => {
              if (item?.Correct_Answer === item[options]) {
                option_flag = 'Right Answer'
              } else {
                option_flag = item[optionFlag[i]]
                option_details.push({
                  option_text: item[options],
                  option_flag: option_flag,
                  option_insight: item[insightText[i]],
                })
              }
            })
          } else if (item?.Question_Type === 'Fill') {
            fillText.map((rightans: any, i: any) => {
              option_details.push({
                right_answer: item[rightans],
                option_insight: item[insightText[i]],
              })
            })
          } else if (item?.Question_Type === 'Match') {
            leftLabelText.map((leftlab: any, i: any) => {
              option_details.push({
                left_label_text: item[leftlab],
                right_label_text: item[rightLabelTextt[i]],
                option_insight: item[insightText[i]],
              })
            })
          } else if (item?.Question_Type === 'ShortAnswer') {
            let cName = 'Component_'
            let rName = 'Rating_'
            let wName = 'Weightage_'
            componentName.map((comp: any, i: any) => {
              option_details.push({
                component_name: item[cName + comp],
                rating_1: item[rName + comp + 1],
                rating_2: item[rName + comp + 2],
                rating_3: item[rName + comp + 3],
                rating_4: item[rName + comp + 4],
                weightage: item[wName + comp],
              })
            })
          }
          if (item?.Title !== '') {
            question_arr.push({
              title: item?.Title,
              description: item?.Description,
              created_by: user?.id,
              creator_id: user?.id,
              status: item?.Status,
              subject_id: item?.Subject?.replace(/\,/g, ''),
              theme_id: item?.Theme === '' ? null : item?.Theme,
              sub_theme_id: item?.Sub_Theme === '' ? null : item?.Sub_Theme,
              topic_id: item?.Topic === '' ? null : item?.Topic,
              grade_ids: item?.Grade === '' ? null : item?.Grade,
              option_type: item?.Option_Type,
              question_type_id: item?.Question_Type,
              bloom_level_id: item?.Bloom_Level === '' ? null : item?.Bloom_Level,
              difficulty_level_id: item?.Difficulty_Level === '' ? null : item?.Difficulty_Level,
              report_theme_id: item?.Report_Theme === '' ? null : item?.Report_Theme,
              centa_standard_id: item?.Centa_Standard === '' ? null : item?.Centa_Standard,
              strand_id: item?.Strand === '' ? null : item?.Strand,
              centa_concept_id: item?.Centa_Concept === '' ? null : item?.Centa_Concept,
              tn_taxonomy_id: item?.Taxonomy === '' ? null : item?.Taxonomy,
              explanation_type_id: item?.Explanation_Type === '' ? null : item?.Explanation_Type,
              competency_id: item?.Competency === '' ? null : item?.Competency,
              teacher_level_id: item?.Teacher_Level === '' ? null : item?.Teacher_Level,
              option_details: option_details,
            })
          }
        })
  
        // mutate({
        //   resource: 'questions',
        //   values: question_arr,
        // })
      }
    }, [array])
  
    const handleOk = () => {
      setIsModalVisible(true)
    }
    const handleExportModalOk = () => {
      setShowExportModal(true)
    }
    const handleExportModalCance = () => {
      setShowExportModal(false)
    }
    const handleCancel = () => {
      setIsModalVisible(false)
    }
    const showModal = (id: string) => {
      setCurrentRecord(id)
      setIsModalVisible(true)
    }
  
   
  
    const [comments, setComments] = useState('')
    var selectedReasons: string[] = []

  
    const { filters, setFilters, tableQueryResult, sorter, current, setCurrent, pageCount, setPageSize } = useTable<IQuestion>({
      resource: 'questions',
      initialSorter: [
        {
          field: 'created_at',
          order: 'desc',
        },
      ],
     
      permanentFilter: [
        { field: 'active', operator: 'eq', value: 'true' },
        { field: 'request_type', operator: 'ne', value: 'Uploaded' },
        { field: 'status', operator: 'ne', value: 'Draft' },
        {
            field: 'retire_by_auto_rules',
            operator: 'eq',
            value: true,
          },
      ],
      metaData,
    })
    useEffect(() => {
      setShowTable(false)
    }, [filters])
    // console.log('tableQueryResult', tableQueryResult?.isFetching)
    //This is needed, because varaintcreator needs
    //access to all question in variant question creation
    useEffect(() => {
      let arrFilter: CrudFilter[] = []
      filters.splice(0, filters.length)
      setFilters([])
  
      setFilters([
       
        {
          field: 'active',
          operator: 'eq',
          value: 'true',
        },
      ])
    
      setWRFilter(arrFilter)
      setQFilter(arrFilter)
      setFilters(arrFilter)
    }, [userRole])
  
    const { queryResult, setShowId } = useShow<IQuestion>({
      resource: 'questions',
      metaData,
    })
  
    const { data: showQueryResult } = queryResult
    const record = showQueryResult?.data
  
  
    const {
      formProps: createFormProps,
      modalProps: createModalProps,
      show: createShow,
    } = useModalForm({
      resource: 'questions',
      action: 'create',
      redirect: false,
      metaData,
    })
    const {
      formProps: editFormProps,
      modalProps: editModalProps,
      close: editClose,
      show: editShow,
    } = useModalForm({
      resource: 'questions',
      action: 'edit',
      redirect: false,
      metaData,
    })
  
    const cancel = (e: React.MouseEvent<HTMLElement>) => {
      message.error('Click on No')
    }
    const onChangeReasons = (checkedValues: any[]) => {
      selectedReasons = checkedValues
    }
  
    const changeFilters = (field: string, value: string, operator: any) => {
      setCurrent(1)
      if (field !== 'all') {
        if (currentFilter === 'status') {
          filters.pop()
        }
  
        setFilters([
          {
            field: field,
            operator: operator,
            value: value,
          },
        ])
      } else if (field === 'all') {
        filters.splice(0, filters.length)
        
      }
  
      setCurrentFilter(field)
    }
    const hideMessage = () => {
      setHideMessage(true)
    }
  
    const gradeList = useList<IGrade>({
      resource: 'grades',
      metaData: {
        fields: ['id', 'name'],
      },
      config: {
        pagination: { pageSize: 1000 },
      },
    })
  
    const columns: TableColumnsType<IQuestion> = [
      {
        dataIndex: 'question_id',
        title: 'Id',
        width: 100,
        key: 'question_id',
        fixed: 'left',
        render: (_, record) => (
          <Text
          style={{
            width: 100,
            textAlign: 'left',
            
          }}
          
        >
          {record?.question_id}
          {'  '}
          {userRole==='qreviewer' && record?.status==='For Second Review'?
          <><Tag color='geekblue'>R2</Tag></>:null
          
        }
        {userRole==='qapprover' && record?.status==='For Second Approval'?
          <><Tag color='geekblue'>A2</Tag></>:null
          
        }
          </Text>
        )
      },
  
      {
        title: 'Name',
        dataIndex: 'name',
        width: 200,
        key: 'name',
        fixed: 'left',
        render: (_, record) => (
          <ShowButton
            size="small"
            type="link"
            icon={null}
            recordItemId={record?.id}
            onClick={() => {
              show('questions', record?.id)
            }}
          >
            <Text
              style={{
                width: 150,
                textAlign: 'left',
                color: '#6659FF',
                cursor: 'pointer',
              }}
              ellipsis={{ tooltip: record?.title }}
            >
              <ReactMarkdown
                allowedElements={ReactMarkdownAllowedElements}
                components={{
                  p: ({ node, ...props }) => <p style={{ margin: '0' }} {...props} />,
                  em: ({ node, ...props }) => <em style={{ margin: '0' }} {...props} />,
                  strong: ({ node, ...props }) => <strong style={{ margin: '0' }} {...props} />,
                  ol: ({ node, ...props }) => <ol style={{ margin: '0' }} {...props} />,
                  ul: ({ node, ...props }) => <ul style={{ margin: '0' }} {...props} />,
                  li: ({ node, ...props }) => <li style={{ margin: '0' }} {...props} />,
                }}
              >
                {record?.title.length < 30 ? record?.title.substring(0, 30) : record?.title.substring(0, 30).concat('...')}
              </ReactMarkdown>
            </Text>
          </ShowButton>
        ),
      },
      {
        dataIndex: 'question_type_id',
        title: 'Q Type',
      },
      {
        dataIndex: 'grade_ids',
        title: 'Grade',
        render: (_, { question_grades, grade_ids }) => (
          <>
            {question_grades?.length > 0 ? (
              <div>
                {question_grades?.length > 1 ? (
                  <Badge size="small" count={question_grades?.length - 1} style={{ background: '#6659ff' }}>
                    {/* <Tooltip title="prompt text" color={'#6659ff'} key={'#6659ff'}> */}
                    <Tag color={'blue'} key={question_grades?.[0]?.grade?.name}>
                      {question_grades?.[0]?.grade?.name}
                    </Tag>
                    {/* </Tooltip> */}
                  </Badge>
                ) : (
                  <Tag color={'blue'} key={question_grades?.[0]?.grade?.name}>
                    {question_grades[0]?.grade?.name}
                  </Tag>
                )}
              </div>
            ) : null}
          
          </>
        ),
      },
      {
        dataIndex: 'topic_id',
        title: 'Topic',
        render: (_, record) => (
          <Text style={{ width: 175, textAlign: 'left' }} ellipsis={{ tooltip: record?.topic?.name }}>
            {record?.topic?.name}
          </Text>
        ),
      },
      {
        dataIndex: 'difficulty_level_id',
        title: 'Difficulty',
        render: (_, record) => (
          <Text style={{ width: 175, textAlign: 'left' }} ellipsis={{ tooltip: record?.difficulty_level?.name }}>
            {record?.difficulty_level?.name}
          </Text>
        ),
      },
      {
        dataIndex: 'bloom_leve_ids',
        title: `Bloom's Level`,
        render: (_, record) => (
          <Text style={{ width: 175, textAlign: 'left' }} ellipsis={{ tooltip: record?.bloom_level?.name }}>
            {record?.bloom_level?.name}
          </Text>
        ),
      },
      {
        dataIndex: 'work_request',
        title: 'WR Name',
        render: (_, record) => (
          <Text style={{ width: 100, textAlign: 'left' }} ellipsis={{ tooltip: record?.work_request?.name }}>
            {record?.work_request?.name}
          </Text>
        ),
      },
      
      {
        dataIndex: 'status',
        title: 'Status',
        className:( userRole === 'qcreator' || userRole==='qreviewer' )? 'hide' : 'show',
        width: 100,
        // className:{ userRole=='qcreator'?`hide-col`:`ant-table-column-sort`},
  
        render: value => (
          <Tag
            color={
              value === 'Published'
                ? 'green'
                : value === 'Rejected at Review' || value === 'Rejected at Approval' || value === 'Retired'
                  ? 'volcano'
                  : value === 'Open (Require Amending)' || value === 'For Review (Require Amending)'
                    ? 'pink'
                    : 'geekblue'
            }
          >
            {value}
          </Tag>
        ),
      },
      {
        dataIndex: 'creator_id',
        title: 'Creator',
        className:( userRole === 'qapprover' || userRole==='qreviewer' )? 'hide' : 'show',
        render: (_, record) => (
          <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.userByCreatorId?.displayName }}>
            {record?.userByCreatorId?.displayName}
          </Text>
        ),
      },
      {
        dataIndex: 'reviewer_id',
        title: 'Reviewer',
        className:( userRole === 'qapprover' || userRole==='qcreator' )? 'hide' : 'show',
        render: (_, record) => (
          <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.userByReviewerId?.displayName }}>
            {record?.userByReviewerId?.displayName}
          </Text>
        ),
      },
      {
        dataIndex: 'approver_id',
        className:( userRole === 'qreviewer' || userRole==='qcreator' )? 'hide' : 'show',
        title: 'Approver',
        render: (_, record) => (
          <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.userByApproverId?.displayName }}>
            {record?.userByApproverId?.displayName}
          </Text>
        ),
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions',
        fixed: 'right',
        width: 100,
        render: (_, record:IQuestion) => (
          <Space>
          
          
          <EditButton
             
              key="edit"
              size="small"
              type="link"
              hideText
              recordItemId={record.id}
              onClick={() => {
                editShow(record?.id)
                setShowId(record?.id)
              }}
            />
             
                
               
            
            
           
          </Space>
        ),
      },
    ]
    const onChange = (page: number, pageSize: number): void => {
      setCurrent(page)
      setPageSize(pageSize)
    }
  
  

    
  
   
    const { handleChange } = useImport<IQuestionType>({
      onFinish: results => {
        window.alert(JSON.stringify(results))
      },
      onProgress: ({ totalAmount, processedAmount }) => {
        //  setProcessed(processedAmount)
        //  setTotal(totalAmount)
      },
    })
   
    const onSelectChange = (selectedRowKeys: React.Key[]) => {
      setSelectedRowKeys(selectedRowKeys)
    }
    const rowSelection = {
      selectedRowKeys,
      onChange: onSelectChange,
      selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE],
      getCheckboxProps: (record: any) => ({
  
      }),
    }
    console.log({ selectedRowKeys })
    const hasSelected = selectedRowKeys.length > 0
  
    console.log({hasSelected})
   
    
    const questionSearch=(value:string)=>{
     
      setFilters(
      [{
        
          field: "title",
          operator: "contains",
          value: `%${value}%`,
        
      }]
      )
          }
    const clearSearch=()=>{
      filters.splice(0, filters.length)
      setFilters([])
  
     formSearch?.resetFields()
     setSearchText('')
     setFilters(qFilter)
      // tableQueryResult?.refetch()
    }
  const republishQuestions=()=>{
    rePublishQuestions({
        resource: "questions",
        values: {
            status: "Open",
            retire_by_auto_rules:false
           
        },
        ids:selectedRowKeys
    });

  }
    return (
      <List
        title="Questions"
        pageHeaderProps={{
          extra: [
            <>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                
  
                <RefreshButton key="refresh" onClick={() => {
                  // clearSearch()
                  
                  tableQueryResult?.refetch()
                  }} style={{ marginLeft: 10 }} />
              </div>
           
            </>,
          ],
        }}
      >
        {hasSelected?
        <>
        
        <Row>
            <Col>
          <Button onClick={republishQuestions}>Revert</Button>
            </Col>
        </Row>
     
        <Divider style={{ margin: ' 0', paddingBottom: 5, marginTop: 20 }} />
        </>
        :null}
        
          
  
     <>
          <Divider style={{ margin: ' 0', paddingBottom: 5, marginTop: 20 }} />
         
          <Form form={formSearch}>
          <Row  gutter={[16, 0]} style={{alignItems:'center'}}>
            <Col lg={22}>
            <Search name="question_search" placeholder="input search text" enterButton="Search" size="large" onSearch={questionSearch} value={searchText} onChange={(e:any)=>setSearchText(e?.target?.value)} />
  
            </Col>
            <Col lg={2}>
              <Button htmlType="button" onClick={clearSearch}>Clear </Button>
              </Col>
            </Row>
            </Form>
            </>
        
          <Divider style={{ margin: ' 0', paddingBottom: 5, marginTop: 20 }}/>
      
     
        <Table
          size="small"
          scroll={{ x: 1500 }}
          dataSource={tableQueryResult?.data?.data}
          rowSelection={rowSelection}
          columns={columns}
          rowKey="id"
          loading={tableQueryResult?.isFetching}
          pagination={{
            total: tableQueryResult?.data?.total,
            onChange,
          }}
         
        />
        
        <EditQuestion
        modalProps={editModalProps}
        formProps={editFormProps}
        record={record}
        close={editClose}
      
        source={'questions_list'}
      />
      
       
        {/* <UploadQuestions modalProps={uploadProps} close={closeUpload} reloadUploadedData={reloadUploadedData} /> */}
      </List>
    )
  }
  